// @todo: Remove this file as this polyfill is now redundant

/* eslint-disable */
if (!Element.prototype.matches)
  // @ts-expect-error TS(2339): Property 'msMatchesSelector' does not exist on typ... Remove this comment to see the full error message
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
